module.exports = __webpack_public_path__ + "static/DSCN6830-107ec43953ec2026b92320b5143add50.webp";